var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "请选择身份",
        width: 450,
        visible: _vm.visible,
        closable: false,
        maskClosable: false,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form",
        [
          _c(
            "a-form-item",
            {
              staticStyle: { "margin-bottom": "10px" },
              attrs: { labelCol: { span: 4 }, wrapperCol: { span: 20 } },
            },
            [
              _c(
                "a-tooltip",
                { attrs: { placement: "topLeft" } },
                [
                  _c("template", { slot: "title" }, [
                    _c("span", [_vm._v("您有多个身份，请选择用户身份")]),
                  ]),
                  _c("a-avatar", {
                    staticStyle: { "background-color": "#87d068" },
                    attrs: { icon: "gold" },
                  }),
                ],
                2
              ),
              _c(
                "a-select",
                {
                  staticStyle: { "margin-left": "10px", width: "80%" },
                  attrs: { placeholder: "请选择用户身份" },
                  on: { change: _vm.handleTenantChange },
                  model: {
                    value: _vm.identityId,
                    callback: function ($$v) {
                      _vm.identityId = $$v
                    },
                    expression: "identityId",
                  },
                },
                [
                  _c("a-icon", {
                    attrs: { slot: "suffixIcon", type: "gold" },
                    slot: "suffixIcon",
                  }),
                  _vm._l(_vm.userIdentityList, function (item) {
                    return _c(
                      "a-select-option",
                      { key: item.value, attrs: { value: item.value } },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.title) + "\n        "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }